/**
 * The step from "staff added" to "first plan published" (2026-09-29): a new company stopped after
 * adding its people and one shift, and never published. While the company has people but has never
 * published a shift (GET /tenant has_published_shift), Vaktplan and Hjem say what comes next. Only
 * to someone who may publish, and gone once a published shift is in sight.
 */
import { useUsers } from '@/api/data';
import { useCan } from '@/auth/caps';
import { T } from '@/i18n';
import { useTenant } from '@/shell/tenant';
import { Icon } from '@/ui/icons';
import { Link } from 'react-router-dom';

export function FirstPlanHint({ on, published = false }: { on: 'vaktplan' | 'hjem'; published?: boolean }) {
  const { tenant, workspace } = useTenant();
  const can = useCan();
  const users = useUsers();
  const people = (users.data ?? []).filter((u) => u.active_status !== false).length;
  // more than the administrator alone, as the morning activation mail counts staff (services/activation.js)
  if (tenant?.has_published_shift !== false || published || people < 2) return null;
  if (!can('vaktplan.endre') || !workspace.enabled.scheduling) return null;
  return (
    <div className="al info" data-testid="first-plan">
      <span>ⓘ</span>
      <span>
        <b>{T('Neste steg: publiser den første vaktplanen.')}</b>{' '}
        {on === 'vaktplan' ? (
          T(
            'Lag vaktene for en uke med Ny vakt, eller klikk i en rute. De lagres som utkast, og de ansatte ser dem først når du trykker Publiser øverst.',
          )
        ) : (
          <>
            {T('De ansatte ser ingen vakter før de er publisert.')}{' '}
            <Link to="/vaktplan">
              <Icon name="calendar" />
              {T('Til vaktplanen')}
            </Link>
            .
          </>
        )}
      </span>
    </div>
  );
}
